export default __webpack_public_path__ + "static/media/verify-email-illustration-dark.e22c4589.svg";